import React, { useEffect, useState } from 'react';

import { Box, Flex, PopoverContent } from '@chakra-ui/react';

import { isMobileView } from 'constants/isMobileView';

import { Button } from 'uiToolkitV1/Button';
import { InputV2 } from 'uiToolkitV1/InputV2';
import { TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  isOpen?: boolean;
  onClose?: () => void;
  onSave?: (link: string, text: string) => void;
  selectedText?: string;
  editorContainerRef?: React.RefObject<HTMLDivElement>;
}

const LinkModal = ({ isOpen, onClose, onSave, selectedText, editorContainerRef }: Props) => {
  const [text, setText] = useState(selectedText);
  const [link, setLink] = useState('');

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  const onLinkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLink(e.target.value);
  };

  useEffect(() => {
    setText(selectedText);
  }, [selectedText]);

  return (
    // <Popover isOpen={isOpen} onClose={onClose}>
    // </Popover>
    <PopoverContent
      maxH="242px"
      maxW={isMobileView() ? '200px' : '316px'}
      sx={{
        top: '-200px',
        left: '100px',
      }}
    >
      <Box p="24px">
        <Flex flexDir="column">
          <TextLabel mb="4px" color="text.g3">
            Text
          </TextLabel>
          <InputV2 isDashed value={text} onChange={onTextChange} />
        </Flex>
        <Flex flexDir="column" mt="12px">
          <TextLabel mb="4px" color="text.g3">
            Link
          </TextLabel>
          <InputV2 isDashed value={link} onChange={onLinkChange} />
        </Flex>
      </Box>
      <Box
        sx={{
          background: '#F5F7F9',
          borderTop: '1px solid #CED7DF',
          borderRadius: '0px 0px 8px 8px',
          p: '12px 16px',
        }}
      >
        <Flex w="100%">
          <Button mr="auto" variant="tertiary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onSave && onSave(link, text);
            }}
            disabled={!link}
          >
            Apply
          </Button>
        </Flex>
      </Box>
    </PopoverContent>
  );
};

export { LinkModal };
